<mds-dialog dialogTitle="Add New Site">
    <mds-dialog-content>
        <medpace-site
            [site]="data.site"
            [isModal]="true"
            [modalFormGroup]="siteFormGroup"
            [isUpdate]="isModalUpdate"
            (infoChangeEvent)="detectInfoChange($event)"
            (addressChangeEvent)="detectAddressChange($event)"
            (paymentChangeEvent)="detectPaymentChange($event)"
            (servicesChangeEvent)="detectServicesChange($event)"
            (crcChangeEvent)="detectCRCChange($event)"
        >
        </medpace-site>
    </mds-dialog-content>
    <mds-dialog-actions [align]="'end'">
        <div class="flex flex-row gap-medpace">
            <mds-button
                [id]="'cancel-btn'"
                mat-button
                mat-dialog-close
                label="Cancel"
                [variant]="'outline'"
                (clickEvent)="onNoClick()"
            ></mds-button>
            <mds-button
                [id]="'site-submit-btn'"
                mat-button
                (clickEvent)="onSubmit()"
                label="Submit"
                [color]="'primary'"
                [variant]="'filled'"
            ></mds-button>
        </div>
    </mds-dialog-actions>
</mds-dialog>
